var render = function render(){
  var _vm$formCustomer, _vm$formCustomer2, _vm$formCustomer3, _vm$customerData, _vm$formCustomer4, _vm$customerData2, _vm$formBilling$billi, _vm$formBilling, _vm$formBilling$billi2, _vm$formBilling2, _vm$formBilling$billi3, _vm$formBilling3, _vm$formBilling$billi4, _vm$formBilling4, _vm$formBilling$billi5, _vm$formBilling5, _vm$formBilling$billi6, _vm$formBilling6, _vm$formBilling$billi7, _vm$formBilling7, _vm$formBilling$billi8, _vm$formBilling8, _vm$formBilling$billi9, _vm$formBilling9, _vm$formBilling$billi0, _vm$formBilling0, _vm$formBilling$billi1, _vm$formBilling1, _vm$formBilling$billi10, _vm$formBilling10;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": _vm.onSave
    }
  }, [_c('b-row', [!_vm.previewData ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end w-100"
  }, [_c('b-button', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "disabled": _vm.saving,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-save"
  }), _c('span', [_vm._v("Submit Data")])])])], 1)]) : _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end w-100"
  }, [_c('b-button', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "block": "",
      "variant": "primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.$nextTick(function () {
          return _vm.$bvModal.hide('new-customer');
        });
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v("Select Customer")])])])], 1)]), _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "* Customer Code",
      "label-for": "customer_code"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_code))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_code",
      "type": "text",
      "placeholder": "Type text",
      "required": ""
    },
    model: {
      value: _vm.formCustomer.customer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_code", $$v);
      },
      expression: "formCustomer.customer_code"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "* Customer Status",
      "label-for": "customer_status"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_status))]) : _c('b-form-select', {
    attrs: {
      "id": "customer_status",
      "plain": "",
      "size": "md"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ''
          }
        }, [_vm._v("Select Customer Status...")]), _c('b-form-select-option', {
          attrs: {
            "value": 'active'
          }
        }, [_vm._v("Active")]), _c('b-form-select-option', {
          attrs: {
            "value": 'on-hold'
          }
        }, [_vm._v("On Hold")]), _c('b-form-select-option', {
          attrs: {
            "value": 'credit-hold'
          }
        }, [_vm._v("Credit Hold")]), _c('b-form-select-option', {
          attrs: {
            "value": 'one-time'
          }
        }, [_vm._v("One-Time")]), _c('b-form-select-option', {
          attrs: {
            "value": 'inactive'
          }
        }, [_vm._v("Inactive")]), _c('b-form-select-option', {
          attrs: {
            "value": 'not-recommended'
          }
        }, [_vm._v("Not Recommended")]), _c('b-form-select-option', {
          attrs: {
            "value": 'blacklist'
          }
        }, [_vm._v("Blacklist")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formCustomer.customer_status,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_status", $$v);
      },
      expression: "formCustomer.customer_status"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "* Customer Class",
      "label-for": "customer_class_id"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.customerClassName(_vm.formCustomer.customer_class_id)))]) : _c('b-form-select', {
    attrs: {
      "id": "customer_class_id",
      "plain": "",
      "size": "md",
      "options": _vm.optionsCustomerClass
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select Customer Class...")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formCustomer.customer_class_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_class_id", $$v);
      },
      expression: "formCustomer.customer_class_id"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "nav-fill mb-3",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-2 p-0",
          attrs: {
            "active": true,
            "href": "#general-customer",
            "title": "General"
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-2 p-0",
          attrs: {
            "active": false,
            "href": "#billing",
            "title": "Billing"
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-2 p-0",
          attrs: {
            "active": false,
            "href": "#contact",
            "title": "Contact"
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-2 p-0",
          attrs: {
            "active": false,
            "href": "#customer-file",
            "title": "Customer File"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('tab-content-item', {
    attrs: {
      "active": true,
      "id": "general-customer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Account Info")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "* Account Name",
      "label-for": "customer_name"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.account_name))]) : _c('b-form-input', {
    attrs: {
      "id": "account_name",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formCustomer.account_name,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "account_name", $$v);
      },
      expression: "formCustomer.account_name"
    }
  })], 1)], 1)], 1)], 1), _c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Account Address")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "* Country",
      "label-for": "customer_country_id"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_country_id))]) : _vm._e(), _c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.optionsCountry,
      "reduce": function reduce(type) {
        return type.value;
      },
      "placeholder": "Select country..."
    },
    model: {
      value: _vm.formCustomer.customer_country_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_country_id", $$v);
      },
      expression: "formCustomer.customer_country_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('FormInputAddress', {
    attrs: {
      "value": _vm.formCustomer.addresses
    },
    model: {
      value: _vm.formCustomer.addresses,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "addresses", $$v);
      },
      expression: "formCustomer.addresses"
    }
  })], 1)], 1)], 1), _c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Additional Account Info")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logo",
      "label-for": "logo"
    }
  }, [!_vm.previewData ? _c('b-form-file', {
    staticClass: "mb-2",
    attrs: {
      "id": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleChangeFileLogo
    },
    model: {
      value: _vm.formCustomer.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "logo", $$v);
      },
      expression: "formCustomer.logo"
    }
  }) : _vm._e(), (_vm$formCustomer = _vm.formCustomer) !== null && _vm$formCustomer !== void 0 && _vm$formCustomer.logo ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": ((_vm$formCustomer2 = _vm.formCustomer) === null || _vm$formCustomer2 === void 0 ? void 0 : _vm$formCustomer2.previewLogo) || ((_vm$formCustomer3 = _vm.formCustomer) === null || _vm$formCustomer3 === void 0 ? void 0 : _vm$formCustomer3.logo),
      "alt": "logo"
    }
  }) : _vm._e(), (_vm$customerData = _vm.customerData) !== null && _vm$customerData !== void 0 && _vm$customerData.logo ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": ((_vm$formCustomer4 = _vm.formCustomer) === null || _vm$formCustomer4 === void 0 ? void 0 : _vm$formCustomer4.previewLogo) || "".concat(_vm.apiUrl, "/").concat((_vm$customerData2 = _vm.customerData) === null || _vm$customerData2 === void 0 ? void 0 : _vm$customerData2.logo),
      "alt": "logo"
    }
  }) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Web",
      "label-for": "customer_web"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_web))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_web",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formCustomer.customer_web,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_web", $$v);
      },
      expression: "formCustomer.customer_web"
    }
  })], 1)], 1)], 1)], 1)]), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Primary Contact")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fullname",
      "label-for": "customer_name"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_name))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_name",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formCustomer.customer_name,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_name", $$v);
      },
      expression: "formCustomer.customer_name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "customer_email"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_email))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_email",
      "type": "email",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formCustomer.customer_email,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_email", $$v);
      },
      expression: "formCustomer.customer_email"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Phone 1",
      "label-for": "customer_phone1"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_phone1))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_phone1",
      "type": "number",
      "placeholder": "Type number"
    },
    model: {
      value: _vm.formCustomer.customer_phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_phone1", $$v);
      },
      expression: "formCustomer.customer_phone1"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Phone 2",
      "label-for": "customer_phone2"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_phone2))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_phone2",
      "type": "number",
      "placeholder": "Type number"
    },
    model: {
      value: _vm.formCustomer.customer_phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_phone2", $$v);
      },
      expression: "formCustomer.customer_phone2"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mobile 1",
      "label-for": "customer_mobile1"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_mobile1))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_mobile1",
      "type": "number",
      "placeholder": "Type number"
    },
    model: {
      value: _vm.formCustomer.customer_mobile1,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_mobile1", $$v);
      },
      expression: "formCustomer.customer_mobile1"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mobile 2",
      "label-for": "customer_mobile2"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_mobile2))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_mobile2",
      "type": "number",
      "placeholder": "Type number"
    },
    model: {
      value: _vm.formCustomer.customer_mobile2,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_mobile2", $$v);
      },
      expression: "formCustomer.customer_mobile2"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Assistant",
      "label-for": "customer_assistant"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_assistant))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_assistant",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formCustomer.customer_assistant,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_assistant", $$v);
      },
      expression: "formCustomer.customer_assistant"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fax",
      "label-for": "customer_fax"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formCustomer.customer_fax))]) : _c('b-form-input', {
    attrs: {
      "id": "customer_fax",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formCustomer.customer_fax,
      callback: function callback($$v) {
        _vm.$set(_vm.formCustomer, "customer_fax", $$v);
      },
      expression: "formCustomer.customer_fax"
    }
  })], 1)], 1)], 1)], 1)])], 1)]), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "billing"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Bill-to Address")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formBilling.billing_from_general ? "From General" : "Not From General"))]) : _c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    on: {
      "change": _vm.handleFromGeneral
    },
    model: {
      value: _vm.formBilling.billing_from_general,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_from_general", $$v);
      },
      expression: "formBilling.billing_from_general"
    }
  }, [_vm._v(" From General ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "* Country",
      "label-for": "billing_country_id"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.formBilling.billing_country_id))]) : _vm._e(), _c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.optionsCountry,
      "reduce": function reduce(type) {
        return type.value;
      },
      "placeholder": "Select country..."
    },
    model: {
      value: _vm.formBilling.billing_country_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_country_id", $$v);
      },
      expression: "formBilling.billing_country_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('FormInputAddress', {
    attrs: {
      "value": _vm.formBilling.addresses
    },
    model: {
      value: _vm.formBilling.addresses,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "addresses", $$v);
      },
      expression: "formBilling.addresses"
    }
  })], 1)], 1)], 1), _c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Bill-to Info")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Account Name",
      "label-for": "billing_account_name"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi = (_vm$formBilling = _vm.formBilling) === null || _vm$formBilling === void 0 ? void 0 : _vm$formBilling.billing_account_name) !== null && _vm$formBilling$billi !== void 0 ? _vm$formBilling$billi : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_account_name",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_account_name,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_account_name", $$v);
      },
      expression: "formBilling.billing_account_name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Attention",
      "label-for": "billing_attention"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi2 = (_vm$formBilling2 = _vm.formBilling) === null || _vm$formBilling2 === void 0 ? void 0 : _vm$formBilling2.billing_attention) !== null && _vm$formBilling$billi2 !== void 0 ? _vm$formBilling$billi2 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_attention",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_attention,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_attention", $$v);
      },
      expression: "formBilling.billing_attention"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bussiness 1",
      "label-for": "billing_business1"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi3 = (_vm$formBilling3 = _vm.formBilling) === null || _vm$formBilling3 === void 0 ? void 0 : _vm$formBilling3.billing_business1) !== null && _vm$formBilling$billi3 !== void 0 ? _vm$formBilling$billi3 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_business1",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_business1,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_business1", $$v);
      },
      expression: "formBilling.billing_business1"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bussiness 2",
      "label-for": "billing_business2"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi4 = (_vm$formBilling4 = _vm.formBilling) === null || _vm$formBilling4 === void 0 ? void 0 : _vm$formBilling4.billing_business2) !== null && _vm$formBilling$billi4 !== void 0 ? _vm$formBilling$billi4 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_business2",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_business2,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_business2", $$v);
      },
      expression: "formBilling.billing_business2"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bussiness 3",
      "label-for": "billing_business3"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi5 = (_vm$formBilling5 = _vm.formBilling) === null || _vm$formBilling5 === void 0 ? void 0 : _vm$formBilling5.billing_business3) !== null && _vm$formBilling$billi5 !== void 0 ? _vm$formBilling$billi5 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_business3",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_business3,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_business3", $$v);
      },
      expression: "formBilling.billing_business3"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cell",
      "label-for": "billing_cell"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi6 = (_vm$formBilling6 = _vm.formBilling) === null || _vm$formBilling6 === void 0 ? void 0 : _vm$formBilling6.billing_cell) !== null && _vm$formBilling$billi6 !== void 0 ? _vm$formBilling$billi6 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_cell",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_cell,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_cell", $$v);
      },
      expression: "formBilling.billing_cell"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Assistant",
      "label-for": "billing_assistant"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi7 = (_vm$formBilling7 = _vm.formBilling) === null || _vm$formBilling7 === void 0 ? void 0 : _vm$formBilling7.billing_assistant) !== null && _vm$formBilling$billi7 !== void 0 ? _vm$formBilling$billi7 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_assistant",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_assistant,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_assistant", $$v);
      },
      expression: "formBilling.billing_assistant"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fax",
      "label-for": "billing_fax"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi8 = (_vm$formBilling8 = _vm.formBilling) === null || _vm$formBilling8 === void 0 ? void 0 : _vm$formBilling8.billing_fax) !== null && _vm$formBilling$billi8 !== void 0 ? _vm$formBilling$billi8 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_fax",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_fax,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_fax", $$v);
      },
      expression: "formBilling.billing_fax"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Home",
      "label-for": "billing_home"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi9 = (_vm$formBilling9 = _vm.formBilling) === null || _vm$formBilling9 === void 0 ? void 0 : _vm$formBilling9.billing_home) !== null && _vm$formBilling$billi9 !== void 0 ? _vm$formBilling$billi9 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_home",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_home,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_home", $$v);
      },
      expression: "formBilling.billing_home"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Home Fax",
      "label-for": "billing_home_fax"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi0 = (_vm$formBilling0 = _vm.formBilling) === null || _vm$formBilling0 === void 0 ? void 0 : _vm$formBilling0.billing_home_fax) !== null && _vm$formBilling$billi0 !== void 0 ? _vm$formBilling$billi0 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_home_fax",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_home_fax,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_home_fax", $$v);
      },
      expression: "formBilling.billing_home_fax"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "billing_email"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi1 = (_vm$formBilling1 = _vm.formBilling) === null || _vm$formBilling1 === void 0 ? void 0 : _vm$formBilling1.billing_email) !== null && _vm$formBilling$billi1 !== void 0 ? _vm$formBilling$billi1 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_email",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_email,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_email", $$v);
      },
      expression: "formBilling.billing_email"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Web",
      "label-for": "billing_web"
    }
  }, [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s((_vm$formBilling$billi10 = (_vm$formBilling10 = _vm.formBilling) === null || _vm$formBilling10 === void 0 ? void 0 : _vm$formBilling10.billing_web) !== null && _vm$formBilling$billi10 !== void 0 ? _vm$formBilling$billi10 : '-'))]) : _c('b-form-input', {
    attrs: {
      "id": "billing_web",
      "type": "text",
      "placeholder": "Type text"
    },
    model: {
      value: _vm.formBilling.billing_web,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "billing_web", $$v);
      },
      expression: "formBilling.billing_web"
    }
  })], 1)], 1)], 1)], 1)]), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Parent Info")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Consolidate Balance? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.consolidate_balance ? "√" : "x"))]) : _c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.consolidate_balance,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "consolidate_balance", $$v);
      },
      expression: "formBilling.consolidate_balance"
    }
  }, [_vm._v(" Consolidate Balance ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Consolidate Statements? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.consolidate_statements ? "√" : "x"))]) : _c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.consolidate_statements,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "consolidate_statements", $$v);
      },
      expression: "formBilling.consolidate_statements"
    }
  }, [_vm._v(" Consolidate Statements ")])], 1)], 1)], 1)], 1), _c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Print and Email Settings")]), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Send invoice by email? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.send_invoice_by_email ? "√" : "x"))]) : _c('b-form-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.send_invoice_by_email,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "send_invoice_by_email", $$v);
      },
      expression: "formBilling.send_invoice_by_email"
    }
  }, [_vm._v(" Send Invoices by Email ")])], 1), _c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Print Invoices? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.print_invoices ? "√" : "x"))]) : _c('b-form-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.print_invoices,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "print_invoices", $$v);
      },
      expression: "formBilling.print_invoices"
    }
  }, [_vm._v(" Print Invoices ")])], 1)], 1)]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Send Statement Email? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.send_statement_email ? "√" : "x"))]) : _c('b-form-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.send_statement_email,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "send_statement_email", $$v);
      },
      expression: "formBilling.send_statement_email"
    }
  }, [_vm._v(" Send Statements by Email ")])], 1), _c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Print Statements? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.print_statements ? "√" : "x"))]) : _c('b-form-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.print_statements,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "print_statements", $$v);
      },
      expression: "formBilling.print_statements"
    }
  }, [_vm._v(" Print Statements ")])], 1)], 1)]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_vm.previewData ? _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Multi Currency Statements? "), _c('br'), _vm._v(" " + _vm._s(_vm.formBilling.multi_currency_statements ? "√" : "x"))]) : _c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formBilling.multi_currency_statements,
      callback: function callback($$v) {
        _vm.$set(_vm.formBilling, "multi_currency_statements", $$v);
      },
      expression: "formBilling.multi_currency_statements"
    }
  }, [_vm._v(" Multi-Currency Statements ")])], 1)], 1)], 1)], 1)])], 1)]), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('a', {
    staticClass: "text-primary mr-4",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.addRowContact
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-2"
  }), _c('span', [_vm._v("Add Row")])])])])]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [!_vm.previewData ? _c('th', {
    staticClass: "text-center align-middle"
  }, [_vm._v("#")]) : _vm._e(), _c('th', {
    staticClass: "text-center align-middle"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Contact")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Job Title")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Division")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Email")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Phone")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Mobile Phone")])])]), _c('tbody', _vm._l(_vm.formContact, function (state, index) {
    return _c('tr', {
      key: index
    }, [!_vm.previewData ? _c('td', [_c('i', {
      staticClass: "fa fa-trash text-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.formContact.splice(index, 1);
        }
      }
    })]) : _vm._e(), _c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_c('b-form-group', [_c('b-form-input', {
      attrs: {
        "id": "contact_name",
        "type": "text",
        "placeholder": "Type text",
        "disabled": _vm.previewData
      },
      model: {
        value: state.contact_name,
        callback: function callback($$v) {
          _vm.$set(state, "contact_name", $$v);
        },
        expression: "state.contact_name"
      }
    })], 1)], 1), _c('td', [_c('b-form-group', [_c('b-form-input', {
      attrs: {
        "id": "contact_job_title",
        "type": "text",
        "placeholder": "Type text",
        "disabled": _vm.previewData
      },
      model: {
        value: state.contact_job_title,
        callback: function callback($$v) {
          _vm.$set(state, "contact_job_title", $$v);
        },
        expression: "state.contact_job_title"
      }
    })], 1)], 1), _c('td', [_c('b-form-group', [_c('b-form-input', {
      attrs: {
        "id": "contact_division",
        "type": "text",
        "placeholder": "Type text",
        "disabled": _vm.previewData
      },
      model: {
        value: state.contact_division,
        callback: function callback($$v) {
          _vm.$set(state, "contact_division", $$v);
        },
        expression: "state.contact_division"
      }
    })], 1)], 1), _c('td', [_c('b-form-group', [_c('b-form-input', {
      attrs: {
        "id": "contact_email",
        "type": "text",
        "placeholder": "Type text",
        "disabled": _vm.previewData
      },
      model: {
        value: state.contact_email,
        callback: function callback($$v) {
          _vm.$set(state, "contact_email", $$v);
        },
        expression: "state.contact_email"
      }
    })], 1)], 1), _c('td', [_c('b-form-group', [_c('b-form-input', {
      attrs: {
        "id": "contact_phone",
        "type": "number",
        "placeholder": "Type number",
        "disabled": _vm.previewData
      },
      model: {
        value: state.contact_phone,
        callback: function callback($$v) {
          _vm.$set(state, "contact_phone", $$v);
        },
        expression: "state.contact_phone"
      }
    })], 1)], 1), _c('td', [_c('b-form-group', [_c('b-form-input', {
      attrs: {
        "id": "contact_mobile",
        "type": "number",
        "placeholder": "Type number",
        "disabled": _vm.previewData
      },
      model: {
        value: state.contact_mobile,
        callback: function callback($$v) {
          _vm.$set(state, "contact_mobile", $$v);
        },
        expression: "state.contact_mobile"
      }
    })], 1)], 1)]);
  }), 0)])])])], 1)], 1)])], 1)]), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "customer-file"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3 mb-2"
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('a', {
    staticClass: "text-primary mr-4",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.addRowCustomer
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-2"
  }), _c('span', [_vm._v("Add Row")])])])]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [!_vm.previewData ? _c('th', {
    staticClass: "text-center align-middle",
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]) : _vm._e(), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._v("Document List")]), _c('th', {
    staticClass: "text-left align-middle",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_vm._v("File")])])]), _c('tbody', _vm._l(_vm.formCustomerFile, function (state, index) {
    return _c('tr', {
      key: index
    }, [!_vm.previewData ? _c('td', [_c('i', {
      staticClass: "fa fa-trash text-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.formCustomerFile.splice(index, 1);
        }
      }
    })]) : _vm._e(), _c('td', [_c('b-form-select', {
      attrs: {
        "id": "document_list_id",
        "plain": "",
        "required": "",
        "size": "md",
        "options": _vm.filteredCustomerFiles(index),
        "disabled": _vm.previewData
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("Select Document...")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.document_list_id,
        callback: function callback($$v) {
          _vm.$set(state, "document_list_id", $$v);
        },
        expression: "state.document_list_id"
      }
    })], 1), _c('td', [_c('b-form-group', [_c('b-form-file', {
      staticClass: "form-control",
      attrs: {
        "plain": "",
        "id": "file",
        "accept": "image/*,application/*",
        "multiple": "",
        "disabled": _vm.previewData
      },
      model: {
        value: state.file,
        callback: function callback($$v) {
          _vm.$set(state, "file", $$v);
        },
        expression: "state.file"
      }
    })], 1), state !== null && state !== void 0 && state.url ? _c('span', {
      staticClass: "text-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview("".concat(_vm.apiUrl, "/").concat(state === null || state === void 0 ? void 0 : state.url), state === null || state === void 0 ? void 0 : state.file_name);
        }
      }
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.file_name))]) : _vm._e()], 1)]);
  }), 0)])])])], 1)], 1)])], 1)])], 1)])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }